import React, { useEffect, useRef, useState, useContext } from "react";
import { External, PlayCircle } from "./ui-icons";
import { sendMessageToParentFrame } from "../helpers/helpers";
import { useTheme } from "@emotion/react";
import { CcRootContext } from "../conversionCenterRoot";

const CcHeaderVideo = ({
  src,
  type = "video/mp4",
  name = null,
  poster = false,
  controls = true,
  controlsList = "",
  disablePictureInPicture = true,
  resizeOnOrientationChange = false,
  ...props
}) => {
  const theme = useTheme();
  const [controlsVisible, setControlsVisible] = useState(false);
  const [isPlaying, setIsPlaying] = useState(false);
  const ctx = useContext(CcRootContext);
  const { landscape } = ctx;
  const videoRef = useRef(null);

  useEffect(() => {
    isPlaying ? videoRef.current.play() : videoRef.current.pause();
  }, [isPlaying]);

  const videoWrapperStyle = {
    position: "relative",
  };

  const playBntStyle = {
    height: 1,
    width: 1,
    opacity: 0,
    position: "absolute",
    zIndex: -1,
    top: 0,
    left: 0,
    pointerEvents: "none",
  };

  const videoStyle = {
    height: resizeOnOrientationChange && landscape ? "100%": "auto",
    width: resizeOnOrientationChange && landscape ? "auto" : "100%",
    maxHeight: resizeOnOrientationChange && landscape ? 104 : 208,
    display: "block",
    margin: "0 auto",
  };
  
  const videoOverlayStyle = {
    position: "absolute",
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    zIndex: 1,
    backgroundColor: "rgba(255,255,255,0.3)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    "& + video": {
      pointerEvents: "none",
    },
  };

  const overlayBtnStyle = {
    backgroundColor: "transparent",
    border: 0,
    color: "#000",
    cursor: "pointer",
    margin: ".5rem",
    "svg": {
      height: "1.5rem",
      color: theme.colors.gray,
    },
  };

  const openInModal = (src, type, poster, name) => {
    sendMessageToParentFrame({
      action: "openModal",
      data: {
        src,
        type,
        poster,
        name,
      },
    });
  };

  return (
    <div css={videoWrapperStyle}>
      <button
        type="button"
        onClick={() => setIsPlaying((prevState) => !prevState)}
        css={playBntStyle}
      >Play/Pause Video</button>
      {!isPlaying && (
        <div css={videoOverlayStyle}>
          <button 
            css={overlayBtnStyle}
            onClick={() => setIsPlaying((prevState) => !prevState)}
          >
            <PlayCircle />
          </button>
          <button
            css={overlayBtnStyle}
            onClick={() => openInModal(src, type, poster, name)}
          >
            <External />
          </button>
        </div>
      )}
      <video
        ref={videoRef}
        src={src}
        type={type}
        controls={controlsVisible}
        controlsList={controlsList}
        disablePictureInPicture={disablePictureInPicture}
        onMouseEnter={() => setControlsVisible(true)}
        onMouseLeave={() => setControlsVisible(false)}
        onPlaying={() => setIsPlaying(true)}
        onEnded={() => setIsPlaying(false)}
        onPause={() => setIsPlaying(false)}
        poster={poster}
        css={videoStyle}
        {...props}
      />
    </div>
  );
};

export default CcHeaderVideo;
